import React, { useState } from "react";
import CommonModal from "../CommonModal/CommonModal";
import { IoMdDownload } from "react-icons/io";
import CommonButton from "../CommonButton/CommonButton";
import "./CommonPreview.scss";

type Props = {
  fileObject: File;
  showDownloadButton?: boolean;
};

const FileViewerObj: React.FC<Props> = ({ fileObject, showDownloadButton = true }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const objectUrl = fileObject ? URL.createObjectURL(fileObject) : undefined;
  const previewUrl = objectUrl || "";

  const fileType = fileObject?.type || "";
  const fileName = fileObject?.name || "file";
  const fileExtension = fileName.split(".").pop()?.toLowerCase() || "";

  const renderFileContent = () => {
    if (fileType.startsWith("image/") || ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
      return <img src={previewUrl} alt="file preview" style={{ maxWidth: "100%" }} />;
    }

    if (fileType.startsWith("video/") || ["mp4", "webm"].includes(fileExtension)) {
      return (
        <video controls width="100%">
          <source src={previewUrl} type={fileType || `video/${fileExtension}`} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (fileType === "application/pdf" || fileExtension === "pdf") {
      return (
        <iframe
          src={previewUrl}
          style={{ width: "100%", height: "600px", border: "none" }}
          title="PDF Viewer"
        />
      );
    }

    if (["doc", "docx"].includes(fileExtension)) {
      const encodedUrl = encodeURIComponent(previewUrl);
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`}
          style={{ width: "100%", height: "600px", border: "none" }}
          title="Word Document Viewer"
        />
      );
    }

    return <p>Preview not supported for this file type.</p>;
  };

  const handlePreviewClick = () => {
    setModalOpen(true);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = previewUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("rel", "noopener noreferrer");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="common-attachment-preview" onClick={handlePreviewClick}>
        {renderFileContent()}
      </div>

      <CommonModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        showCloseIcon={true}
        title=""
        size="xl"
        bodyContent={
          <div className="m-3">
            <div className="mb-3">{renderFileContent()}</div>
          </div>
        }
        footerContent={
          showDownloadButton ? (
            <div className="me-3 float-right">
              <CommonButton
                btnText="&nbsp;Download"
                onClick={handleDownload}
                className="w-auto ps-4 pe-4 mb-2 default-text"
                height="40px"
                backgroundColor="transparent"
                border="2px solid var(--primary-text-color)"
                icon={IoMdDownload}
                borderRadius="8px"
              />
            </div>
          ) : null
        }

      />
    </>
  );
};

export default FileViewerObj;
